import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Anchor, Box, Grommet } from "grommet";
import * as React from "react";
import { BrowserRouter, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import DarkModeSwitch, { useDarkMode } from "./components/DarkModeSwitch";
import LinkAnchor from "./components/LinkAnchor";
import FactionsHome from "./FactionsHome";
import Home from "./Home";
import ThemesHome from "./ThemesHome";
import Theme from "./utils/Theme";
import Artefaxist from "./Artefaxist";
import ImagesHome from "./images/ImagesHome";
import { CardWrapper } from "./CardWrapper";

function App() {
    const [isDarkMode, toggleDarkMode] = useDarkMode();
    const [showDarkModeSwitch, setShowDarkModeSwitch] = React.useState(true);

    return (
        <Grommet id="main" full theme={Theme} themeMode={isDarkMode ? "dark" : "light"}>
            {showDarkModeSwitch && <DarkModeSwitch></DarkModeSwitch>}
            <BrowserRouter>
                {/* <Box direction="row" gap="small">
                    <LinkAnchor label={"Artefaxist"} path="/"></LinkAnchor>
                    <LinkAnchor label={"Home"} path="/home"></LinkAnchor>
                    <LinkAnchor label={"Factions"} path="/factions"></LinkAnchor>
                    <LinkAnchor label={"Themes"} path="/Themes"></LinkAnchor>
                    <LinkAnchor label={"Images"} path="/images"></LinkAnchor>
                </Box> */}
                <Routes>
                    <Route path="/" element={<Artefaxist />}></Route>
                    <Route path="/home" element={<Home />}></Route>
                    <Route path="/factions" element={<FactionsHome />}></Route>
                    <Route path="/themes" element={<ThemesHome />}></Route>
                    <Route path="/images" element={<ImagesHome />}></Route>
                    <Route path="/card/:id" element={<CardWrapper />}></Route>
                </Routes>
            </BrowserRouter>
        </Grommet>
    );
}

export default App;
